import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    z-index: 999;
  `,
  content: css`
    width: 600px;
    max-height: 600px;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
